import { render, staticRenderFns } from "./wanjie.vue?vue&type=template&id=e9023c7c&scoped=true"
import script from "./wanjie.vue?vue&type=script&lang=js"
export * from "./wanjie.vue?vue&type=script&lang=js"
import style0 from "./wanjie.vue?vue&type=style&index=0&id=e9023c7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9023c7c",
  null
  
)

export default component.exports